import { MeasurementUtils, TransformUtils } from '@inter-ikea-core/core';
import { EntityApi, ProductType, transformOuterMeasurements } from '@inter-ikea-storageone/range';
export class KnoxhultEntityApi extends EntityApi {
    constructor() {
        super(...arguments);
        /**
         * Adjust the outer measurements for cabinets that are aligned with to the corner cabinet on the other wall.
         * This is so the measurements are correctly displayed into the corner.
         */
        this.adjustForCornerFrame = (wallEntities, wall, measurements) => {
            const hasSameRotation = (entity, alignedFrame) => {
                return TransformUtils.worldRotation(entity).equals(TransformUtils.worldRotation(alignedFrame));
            };
            const CORNER_FRAME_DEPTH = 610;
            let adjustedMeasurements = measurements;
            wallEntities.forEach(entity => {
                const alignedFrames = this.getAlignedFrames(entity, 'align-cabinet-left', 'align-cabinet-right', false, false);
                if (alignedFrames.left &&
                    this.isProductType(alignedFrames.left, ProductType.KNOXHULT_CORNER_CABINET) &&
                    !hasSameRotation(entity, alignedFrames.left)) {
                    // Entity is aligned to a corner frame on the left that stands on the other wall. We need to adjust the measurements
                    // to account for the corner frame depth so the measurements are displayed into the corner.
                    if (wall === 'front') {
                        adjustedMeasurements = {
                            ...adjustedMeasurements,
                            width: adjustedMeasurements.width + CORNER_FRAME_DEPTH,
                            min: {
                                ...adjustedMeasurements.min,
                                x: adjustedMeasurements.min.x - CORNER_FRAME_DEPTH
                            }
                        };
                    }
                    else if (wall === 'right') {
                        adjustedMeasurements = {
                            ...adjustedMeasurements,
                            width: adjustedMeasurements.width + CORNER_FRAME_DEPTH,
                            min: {
                                ...adjustedMeasurements.min,
                                z: adjustedMeasurements.min.z - CORNER_FRAME_DEPTH
                            }
                        };
                    }
                    else if (wall === 'left') {
                        adjustedMeasurements = {
                            ...adjustedMeasurements,
                            width: adjustedMeasurements.width + CORNER_FRAME_DEPTH,
                            max: {
                                ...adjustedMeasurements.max,
                                z: adjustedMeasurements.max.z + CORNER_FRAME_DEPTH
                            }
                        };
                    }
                    else if (wall === 'back') {
                        adjustedMeasurements = {
                            ...adjustedMeasurements,
                            width: adjustedMeasurements.width + CORNER_FRAME_DEPTH,
                            max: {
                                ...adjustedMeasurements.max,
                                x: adjustedMeasurements.max.x + CORNER_FRAME_DEPTH
                            }
                        };
                    }
                }
                else if (alignedFrames.right &&
                    this.isProductType(alignedFrames.right, ProductType.KNOXHULT_CORNER_CABINET) &&
                    !hasSameRotation(entity, alignedFrames.right)) {
                    // Entity is aligned to a corner frame on the right that stands on the other wall. We need to adjust the measurements
                    // to account for the corner frame depth so the measurements are displayed into the corner.
                    if (wall === 'front') {
                        adjustedMeasurements = {
                            ...adjustedMeasurements,
                            width: adjustedMeasurements.width + CORNER_FRAME_DEPTH,
                            max: {
                                ...adjustedMeasurements.max,
                                x: adjustedMeasurements.max.x + CORNER_FRAME_DEPTH
                            }
                        };
                    }
                    else if (wall === 'right') {
                        adjustedMeasurements = {
                            ...adjustedMeasurements,
                            width: adjustedMeasurements.width + CORNER_FRAME_DEPTH,
                            max: {
                                ...adjustedMeasurements.max,
                                z: adjustedMeasurements.max.z + CORNER_FRAME_DEPTH
                            }
                        };
                    }
                    else if (wall === 'left') {
                        adjustedMeasurements = {
                            ...adjustedMeasurements,
                            width: adjustedMeasurements.width + CORNER_FRAME_DEPTH,
                            min: {
                                ...adjustedMeasurements.min,
                                z: adjustedMeasurements.min.z - CORNER_FRAME_DEPTH
                            }
                        };
                    }
                    else if (wall === 'back') {
                        adjustedMeasurements = {
                            ...adjustedMeasurements,
                            width: adjustedMeasurements.width + CORNER_FRAME_DEPTH,
                            min: {
                                ...adjustedMeasurements.min,
                                x: adjustedMeasurements.min.x - CORNER_FRAME_DEPTH
                            }
                        };
                    }
                }
            });
            return adjustedMeasurements;
        };
    }
    /**
     * @override handle KNOXHULT corner frame
     */
    getOuterMeasurementsPerWall() {
        const groupedEntities = this.getOuterMeasurementEntitiesPerWall();
        if (!groupedEntities) {
            return null;
        }
        return Object.entries(groupedEntities).reduce((acc, [wall, entities]) => {
            const outsideMeasurements = MeasurementUtils.getOutsideMeasurementWithoutHierarchies(entities);
            if (!outsideMeasurements) {
                return acc;
            }
            const transformedMeasurements = transformOuterMeasurements(outsideMeasurements, wall === 'left' || wall === 'right');
            if (transformedMeasurements === null) {
                return acc;
            }
            const measurements = this.adjustForCornerFrame(entities, wall, transformedMeasurements);
            return {
                ...acc,
                [wall]: measurements
            };
        }, {});
    }
}
//# sourceMappingURL=KnoxhultEntityApi.js.map